<template>
  <div class="col-sm-auto py-2">

    <button class="btn btn-sm btn-outline-primary font-weight-bolder my-auto"
            data-toggle="modal" data-target="#add-crew-behaviour"
            style="opacity: .75">
      <i class="fas fa-plus"></i>
      Add New
    </button>

    <cms-modal unique="add-crew-behaviour" title="Add New Crew Incident / Behavior" :screen-height="true"
               :size="newCrewIncident.incident_id == 12 ? 'xl' : ''"
    >
      <form @submit.prevent="confirmAddCrewIncident" class="row">
        <div class="col" style="height: 80vh"
             :class="{'col-12': newCrewIncident.incident_id != 12, 'col-5': newCrewIncident.incident_id == 12}"
        >
          <div class="form-group row mb-0" :class="{'has-error': newCrewIncidentErrors.incident_id }">
            <label for="new-behaviour-type"
                   class="col-sm-4 col-form-label font-weight-bolder"
            >Type:</label>
            <div class="col-sm-8 pl-0 text-center">
              <select id="new-behaviour-type" required
                      class="custom-select custom-select-sm"
                      v-model="newCrewIncident.incident_id"
              >
                <option :value="undefined">- Select Incident -</option>
                <option v-for="incidentKey in incidentKeys"
                        :key="incidentKey.id"
                        :value="incidentKey.id"
                >{{ incidentKey.name }}
                </option>
              </select>
              <span class="help-block" v-if="newCrewIncidentErrors.incident_id !== ''">
                    <small><strong>{{ newCrewIncidentErrors.incident_id }}</strong></small>
                  </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': newCrewIncidentErrors.vessel_id }">
            <label for="new-vessel-id"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Vessel:</label>
            <div class="col-sm-8 pl-0">

              <VesselDropdown
                  id="new-vessel-id"
                  v-model="newCrewIncident.vessel_id"
                  :selections="vesselKeys"
                  identifier="vessel"
                  :other-function="getOtherVesselKeys"
              ></VesselDropdown>

              <span class="help-block" v-if="newCrewIncidentErrors.vessel_id !== ''">
                  <small><strong>{{ newCrewIncidentErrors.vessel_id }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-1">
            <label class="col-sm-4 col-form-label font-weight-bold"
                   for="new-at-sea"
            >At Sea
            </label>
            <div class="col-sm-8 pl-1">
              <div class="form-check">
                <input class="form-check-input scale-1-half" type="checkbox" id="new-at-sea" aria-label="At Sea"
                       v-model="atSea"
                >
              </div>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': newCrewIncidentErrors.port_id }">
            <label for="new-port-from"
                   class="col-sm-4 col-form-label font-weight-bold"
            >
              {{ atSea ? 'Port From' : 'Port' }}:
            </label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="new-port-from"
                      v-model="newCrewIncident.port_id"
              >
                <option :value="0">- Select Port -</option>
                <option v-for="fromPortKey in portKeys" :key="fromPortKey.id"
                        :value="fromPortKey.id">{{ fromPortKey.name }}
                </option>
              </select>
              <span class="help-block" v-if="newCrewIncidentErrors.port_id !== ''">
                  <small><strong>{{ newCrewIncidentErrors.port_id }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-0" id="portToDiv" v-if="atSea"
               :class="{'has-error': newCrewIncidentErrors.to_port_id }">
            <label for="new-port-to"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Port To:</label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="new-port-to"
                      v-model="newCrewIncident.to_port_id"
              >
                <option :value="0">- Select -</option>
                <option v-for="toPortKey in portKeys" :key="toPortKey.id"
                        :value="toPortKey.id">{{ toPortKey.name }}
                </option>
              </select>
              <span class="help-block" v-if="newCrewIncidentErrors.to_port_id !== ''">
                  <small><strong>{{ newCrewIncidentErrors.to_port_id }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': newCrewIncidentErrors.incident_date }">
            <label for="new-incident-date"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Date:</label>
            <div class="col-sm-8 pl-0 text-center">
              <input type="date" id="new-incident-date" class="form-control form-control-sm"
                     v-model="newCrewIncident.incident_date"
              >
              <span class="help-block" v-if="newCrewIncidentErrors.incident_date !== ''">
                  <small><strong>{{ newCrewIncidentErrors.incident_date }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-2" :class="{'has-error': newCrewIncidentErrors.remarks }">
            <label for="new-remarks" class="col-sm-4 col-form-label font-weight-bold">Remarks:</label>
            <div class="col-sm-8 pl-0">
                <textarea class="form-control form-control-sm" id="new-remarks" rows="3"
                          v-model="newCrewIncident.remarks"
                          style="resize: none"
                ></textarea>
              <span class="help-block" v-if="newCrewIncidentErrors.remarks !== ''">
                  <small><strong>{{ newCrewIncidentErrors.remarks }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': newCrewIncidentErrors.manning_id }">
            <label for="new-manning-id" class="col-sm-4 col-form-label font-weight-bold"> Manning </label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="new-manning-id"
                      v-model="newCrewIncident.manning_id"
              >
                <option :value="0">- Select Manning -</option>
                <option v-for="manningKey in manningKeys" :key="manningKey.id"
                        :value="manningKey.id">{{ manningKey.alias }}
                </option>
              </select>
              <span class="help-block" v-if="newCrewIncidentErrors.manning_id !== ''">
                  <small><strong>{{ newCrewIncidentErrors.manning_id }}</strong></small>
                </span>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label for="new-viewable" class="col-sm-4 col-form-label font-weight-bold">Viewable to <br/> All Manning
            </label>
            <div class="col-sm-4 pt-3">
              <div class="form-check-inline">
                <input type="checkbox" id="new-viewable" class="form-check-input"
                       v-model="newCrewIncident.viewable"
                >
              </div>
            </div>
          </div>

          <div class="form-group row mb-2 py-2 bg-light border-top"
               v-for="(newCrewIncidentAttachment, index) in newCrewIncidentAttachments" :key="index">
            <label :for="'attachment' + index" class="col-sm-4 col-form-label font-weight-bold">Attachment {{
                index + 1
              }}:</label>
            <div class="col-sm-8 pl-0 mb-2">
              <div class="custom-file form-control-sm">
                <input type="file" class="custom-file-input"
                       :id="'attachment' + index" required
                       accept="application/pdf"
                       @change="updateFileLabel(index)"
                >
                <label class="custom-file-label"
                       :for="'attachment' + index"
                       :id="'label' + index"
                >Choose file</label>
              </div>
            </div>
            <label for="fileDescription" class="col-sm-4 col-form-label font-weight-bold">
              Description: <br/>

              <button type="button"
                      class="float-right btn btn-outline-danger border-0 p-1 align-self-center font-weight-bold"
                      @click="removeAttachmentIndex(index)"
              >
                <i class="fas fa-minus-circle"></i>Remove
              </button>
            </label>
            <div class="col-sm-8 pl-0">
                <textarea id="fileDescription" rows="3"
                          class="form-control form-control-sm"
                          v-model="newCrewIncidentAttachment.description"
                          style="resize: none"
                ></textarea>
            </div>
          </div>
          <button type="button" class="btn btn-outline-success border-0 p-1 border-top"
                  @click="addCrewIncidentAttachment"
          >
            <i class="fas fa-plus-circle mr-1"></i>File
          </button>

          <div class="border-top border-dark text-right p-2 mt-2">
            <button type="submit" class="btn btn-outline-primary btn-sm font-weight-bold ml-auto mr-2"
                    style="opacity: .75">
              <i class="fas fa-save"></i>
              Save
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm font-weight-bold" data-dismiss="modal">
              <i class="fas fa-times"></i>
              Cancel
            </button>
          </div>

        </div>
        <div class="col col-7 border-left border-secondary" v-if="newCrewIncident.incident_id == 12">
          <label class="lead font-weight-bolder">Select VDR Observations Here</label>
          <!--          <div class="form-check mb-1" v-for="vdrObservationKey in vdrObservationKeys" :key="vdrObservationKey.id">-->
          <!--            <input class="form-check-input" type="checkbox"-->
          <!--                   :id="`observation-${vdrObservationKey.id}`"-->
          <!--                   :value="vdrObservationKey.id"-->
          <!--                   v-model="observations"-->
          <!--            >-->
          <!--            <label class="form-check-label" :for="`observation-${vdrObservationKey.id}`"-->
          <!--                   :class="{'font-weight-bolder': observations.includes(vdrObservationKey.id)}"-->
          <!--            ><span class="mr-2">{{vdrObservationKey.code}}.</span>{{ vdrObservationKey.observation }}</label>-->
          <!--          </div>-->

          <table class="table table-hover table-bordered text-small border-left table-template-1"
                 v-if="newCrewIncident.incident_id == 12">
            <thead>
            <tr>
              <th></th>
              <th>Code</th>
              <th>Observation</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="vdrObservationKey in vdrObservationKeys">
              <tr :key="vdrObservationKey.id">
                <td style="height: 3vh;">
                  <input type="checkbox"
                         :id="`observation-${vdrObservationKey.id}`"
                         :value="vdrObservationKey.id"
                         v-model="observations"
                  >
                </td>
                <td class="text-right">
                  {{ vdrObservationKey.code }}
                </td>
                <td>
                  {{ vdrObservationKey.observation }}
                </td>

              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </form>
    </cms-modal>

  </div>

</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {mapActions, mapGetters} from 'vuex';

import CmsModal from "@/components/elements/CmsModal";
import VesselDropdown from "@/components/elements/VesselDropdown";

export default {
  name: "AddCrewBehaviour",
  mixins: [vueAppMixin],

  components: {
    VesselDropdown,
    CmsModal
  },

  data() {
    return {
      newCrewIncident: {},
      newCrewIncidentAttachments: [],
      newCrewIncidentErrors: {},
      atSea: false,
      observations: []
    }
  },

  methods: {
    ...mapActions(['addCrewIncident', 'getOtherVesselKeys', 'getCrewInfo']),

    async confirmAddCrewIncident() {
      if (await this.confirmCreateAlert()) {
        let formData = new FormData();

        Object.keys(this.newCrewIncident).forEach(key => {
          let value = this.newCrewIncident[key] ? this.newCrewIncident[key] : '';
          formData.append(key, value);
        });

        formData.append('viewable', (this.newCrewIncident.viewable ? 1 : 0));

        this.newCrewIncidentAttachments.forEach((newCrewIncidentAttachment, index) => {
          let attachment = document.getElementById(`attachment` + index);
          if (attachment.files && attachment.files[0]) {
            let file = attachment.files[0];
            formData.append(`attachment` + index, file);
          }
        });

        formData.append('newCrewIncidentAttachments', JSON.stringify(this.newCrewIncidentAttachments));

        if (this.newCrewIncident.incident_id == 12) {
          this.observations.forEach((observation, index) => formData.append(`vdrObservations[${index}]`, observation));
        }

        let newCrewIncident = await this.addCrewIncident(formData);

        console.log(newCrewIncident, 'newCrewIncident');

        if (newCrewIncident) {
          if (newCrewIncident.errors) {
            this.newCrewIncidentErrors = newCrewIncident.errors;
          } else {
            document.getElementById('close-add-crew-behaviour').click();
            this.successAlert('New Crew Incident Successfully Added', 'CREATE');
            this.refreshNewCrewIncident();
          }
        }
      }
    },

    updateFileLabel(index) {
      let fileInput = document.getElementById('attachment' + index);
      let fileLabel = document.getElementById('label' + index);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files[0]) {
        let file = fileInput.files[0];
        labelText = file.name;
      }
      fileLabel.innerHTML = labelText;
    },

    refreshNewCrewIncident() {
      this.newCrewIncident = {
        crew_id: this.crew.id,
        incident_date: '',
        remarks: '',
        incident_id: undefined,
        vessel_id: 0,
        port_id: 0,
        to_port_id: 0,
        manning_id: this.crew.manning_id,
        viewable: false
      };

      this.newCrewIncidentErrors = {
        incident_date: '',
        remarks: '',
        incident_id: '',
        vessel_id: '',
        port_id: '',
        to_port_id: '',
        manning_id: '',
        viewable: ''
      };
      this.atSea = false;
      this.newCrewIncidentAttachments = [];
      this.addCrewIncidentAttachment();
    },

    addCrewIncidentAttachment() {
      this.newCrewIncidentAttachments.push({
        description: ''
      });
    },

    removeAttachmentIndex(index) {
      this.newCrewIncidentAttachments.splice(index, 1);
    }

  },

  computed: {
    ...mapGetters([
      'incidentKeys',
      'vesselKeys',
      'portKeys',
      'vdrObservationKeys',
      'manningKeys',
      'crew',
    ])
  },

  created() {
    this.refreshNewCrewIncident();
  }

}
</script>

<style scoped>

.scale-1-half {
  transform: scale(1.5);
}

</style>